import dialogTemplate from "./configureInvoiceTypesDialog/configureInvoiceTypesDialog.html";
import ConfigureInvoiceTypesDialogController from "./configureInvoiceTypesDialog/configureInvoiceTypesDialog.controller";

class Controller {
  constructor($state, Sections, Events, $mdDialog, InvoiceItemType) {
    "ngInject";

    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.sections = Sections.settingsSections;
    this.Events = Events;
    this.InvoiceItemType = InvoiceItemType;
    this.paginateEvent = Events.getPaginateEvent("invoiceTypes");
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;

    this.resourceParams = {
      category: [
        "manual_adjustment",
        "manual_bonus",
        "manual_deduction",
        "payment",
      ],
      active: true,
    };
  }

  openDialog() {
    this.$mdDialog
      .show({
        controllerAs: "$ctrl",
        controller: ConfigureInvoiceTypesDialogController,
        template: dialogTemplate,
      })
      .then((model) => {
        this.InvoiceItemType.post(model).$promise.then(
          (response) => {
            this.Events.emit(this.successNotificationEvent, {
              message: `Your Manual Invoice Item Type has been added successfully.`,
            });
            this.$state.transitionTo("manualinvoiceitem", {
              id: response._id,
            });
          },
          (response) =>
            this.Events.emit(this.errorNotificationEvent, response.data)
        );
      });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/manualInvoiceItems/manualInvoiceItems.controller.js